import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

export function useClearPath(keys: string[]) {
  const pathName = usePathname();
  const searchParams = useSearchParams();

  // Callers pass a fresh array literal each render; join to a stable primitive
  // so the effect only re-runs when the keys actually change.
  const keysKey = keys.join(",");

  useEffect(() => {
    const keyList = keysKey.split(",");
    if (!keyList.some((key) => searchParams.has(key))) {
      return;
    }

    // Drop only the requested keys, preserving all other params (including
    // empty-valued ones), and replace the entry so no back-nav stop is added.
    const params = new URLSearchParams(searchParams);
    for (const key of keyList) {
      params.delete(key);
    }
    const query = params.toString();
    window.history.replaceState(
      null,
      "",
      query ? `${pathName}?${query}` : pathName,
    );
  }, [keysKey, pathName, searchParams]);
}
